import React, { useEffect, useState } from 'react';
import partnerService from '../../services/KangarooServices/PartnerService';
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  CardBody, 
  CardTitle, 
  Badge, 
  Alert, 
  Spinner 
} from 'reactstrap';
import { useParams } from 'react-router-dom';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { imageBaseApi } from '../../utilis/imageHelper';

const PartnerDetails = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDetail = async () => {
    setLoading(true);
    
    try {
      const response = await partnerService.getDetail(id);
      setDetails(response || []); 
    } catch (err) {
      console.error(err);
      setError("Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [id]);

  const partnerDetails = details?.partnerDetails || [];

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb 
          title="Partner Details" 
          pageTitle="Partners" 
          breadcrumbItems={[{ title: "Back to List", link: "/partners" }]}
        />

        {/* Loading Spinner */}
        {loading && !error && (
          <div className="text-center my-5 py-5">
            <Spinner style={{ width: '3rem', height: '3rem' }} />
            <p className="text-muted mt-3">Loading...</p>
          </div>
        )}

        {/* Error Alert */}
        {error && !loading && (
          <Alert color="danger">{error}</Alert>
        )}

        {/* Partner Details */}
        {details && !loading && (
          <>
            {/* Main Partner Card */}
            <Row className="mb-2">
              <Col lg="12">
                <Card className="border shadow-sm">
                  <CardBody className="p-4">
                    <div className="d-flex justify-content-between align-items-start flex-wrap">
                      <div className="mb-3 mb-md-0">
                        <h5 className="mb-2 fw-bold">
                          {details.name || "Unnamed Partner"}
                        </h5>
                        <p className="text-muted mb-0">
                          Partner Information
                        </p>
                      </div>
                      <Badge color="primary" className="px-3 py-2 border">
                        Order: {details.orderIndex ?? "N/A"}
                      </Badge>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* Associated Partners Section */}
            <Row className="mb-3">
              <Col lg="12">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <h5 className="mb-0 fw-semibold">
                    Associated Partners
                  </h5>
                  <Badge color="light" pill className="px-3 py-2 border">
                    {partnerDetails.length}
                  </Badge>
                </div>
              </Col>
            </Row>

            {partnerDetails.length > 0 ? (
              <Row>
                {partnerDetails.map((partner) => (
                  <Col lg="6" xl="4" key={partner.id} className="mb-4">
                    <Card className="border shadow-sm h-100">
                      <CardBody className="p-4 d-flex flex-column">
                        {/* Partner Logo */}
                        {partner.media?.url && (
                          <div className="text-center mb-4 p-3 bg-light rounded">
                            <img 
                              src={`${imageBaseApi}${partner.media.url}`}
                              alt={partner.name}
                              className="img-fluid"
                              style={{ 
                                maxHeight: '100px',
                                objectFit: 'contain'
                              }}
                            />
                          </div>
                        )}

                        {/* Partner Name */}
                        <CardTitle tag="h5" className="mb-3 text-center fw-semibold">
                          {partner.name || "Unnamed Partner"}
                        </CardTitle>

                        {/* Partner Order */}
                        <div className="text-center mt-auto">
                          <Badge color="primary" className="px-3 py-2 border">
                            Display Order: {partner.orderIndex ?? "N/A"}
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <Row>
                <Col lg="12">
                  <Card className="border-0 bg-light">
                    <CardBody className="text-center py-5">
                      <p className="text-muted mb-0">
                        No partners associated with this item.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default PartnerDetails;